<template>
	<div :class="[classes, spacing]" data-testid="alert">
		<div class="flex gap-2 items-center">
			<div class="flex-shrink-0">
				<CheckCircleIcon
					v-if="theme == 'success'"
					:class="iconClasses"
					data-testid="success-icon"
					aria-hidden="true" />
				<ExclamationTriangleIcon
					v-else-if="theme == 'warning'"
					:class="iconClasses"
					data-testid="warning-icon"
					aria-hidden="true" />
				<ExclamationTriangleIcon
					v-else-if="theme == 'danger'"
					:class="iconClasses"
					data-testid="danger-icon"
					aria-hidden="true" />
				<ExclamationCircleIcon
					v-else
					:class="iconClasses"
					aria-hidden="true"
					data-testid="info-icon" />
			</div>
			<slot></slot>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { computed } from 'vue'
	import {
		CheckCircleIcon,
		ExclamationTriangleIcon,
		ExclamationCircleIcon
	} from '@heroicons/vue/20/solid'

	const props = withDefaults(
		defineProps<{
			theme?: 'primary' | 'secondary' | 'success' | 'info' | 'warning' | 'danger'
			compact?: boolean
			spacing?: string
		}>(),
		{
			theme: 'primary',
			compact: false,
			spacing: 'mb-4'
		}
	)

	const classes = computed(() => ({
		'w-full rounded-md text-sm ring-1': true,
		'bg-mabey-50 text-mabey-950 ring-mabey-500/10': props.theme == 'primary',
		'bg-cyan-50 text-cyan-600 ring-cyan-500/10': props.theme == 'secondary',
		'bg-green-50 text-green-600 ring-green-500/10': props.theme == 'success',
		'bg-blue-50 text-blue-600 ring-blue-500/10': props.theme == 'info',
		'bg-yellow-50 text-yellow-600 ring-yellow-500/10': props.theme == 'warning',
		'bg-red-50 text-red-600 ring-red-500/10': props.theme == 'danger',
		'p-3': !props.compact,
		'px-3 py-2': props.compact
	}))

	const iconClasses = computed(() => ({
		'h-5 w-5': true,
		'text-mabey-500': props.theme == 'primary',
		'text-cyan-400': props.theme == 'secondary',
		'text-green-400': props.theme == 'success',
		'text-blue-400': props.theme == 'info',
		'text-yellow-400': props.theme == 'warning',
		'text-red-400': props.theme == 'danger'
	}))
</script>
